<template>
    <header>
            <div class="container-fluid top-menu row no-gutters">
                <div class="fluid-container header-wrapper">
                    <div class="row">
                    <router-link to="/" class="logo-tag">
                        <div class="logo"></div>
                    </router-link>
                        <MobileMenu></MobileMenu>
                        <div class="col-xl-6 py-2 navigation">
                          <ul class="header-nav-items menu">
                              <li>
                                  <router-link class="header-nav-link" to="/our-services/">Our Services</router-link>
                              </li>
                              <li>
                                  <router-link class="header-nav-link" to="/why-use-us/">Why Use Us</router-link>
                              </li>
                              <li>
                                  <router-link class="header-nav-link" to="/testimonials/">Testimonials</router-link>
                              </li>
                              <li>
                                  <router-link class="header-nav-link" to="/contact-us/">Contact Us</router-link>
                              </li>
                              <li>
                                  <a href="tel:07950189260"><img src="@/assets/images/phone.png"><strong class="header-nav-link"> 07950 189 260</strong></a>
                              </li>
                          </ul>
                        </div>
                    </div>
                </div>
            </div>
        </header>
</template>

<script>

import MobileMenu from '@/components/partials/MobileMenu'

export default {
  name: 'main-header',
  components: {
    MobileMenu
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/partials/MainHeader.vue